import { Injectable } from '@angular/core';
import { HttpMethodType } from '@app/app.constant';
import { HttpCallService } from '@app/core/services/http-call.service';
import { INotificationTemplateHttpResponse, NotificationTemplate } from '@app/models/notification-settings';
import { map, Observable } from 'rxjs';

const HttpServiceMethods = {
  NotificationTemplate: 'NotificationTemplate'
};
@Injectable({
  providedIn: 'root'
})
export class NotificationTemplatesService {

  constructor(private httpService: HttpCallService) { }

  public list(): Observable<NotificationTemplate[]> {
    return this.httpService
      .callService(HttpMethodType.GET, HttpServiceMethods.NotificationTemplate)
      .pipe(
        map((res) => res.map((item: INotificationTemplateHttpResponse) => NotificationTemplate.adapt(item)))
      );
  }

  public get(id: number): Observable<NotificationTemplate> {
    return this.httpService
      .callService(HttpMethodType.GET, HttpServiceMethods.NotificationTemplate + `/${id}`)
      .pipe(map((item: INotificationTemplateHttpResponse) => NotificationTemplate.adapt(item)));
  }

  public add(parameterType: NotificationTemplate) {
    return this.httpService.callService(
      HttpMethodType.POST,
      HttpServiceMethods.NotificationTemplate,
      parameterType
    );
  }

  public update(parameterType: NotificationTemplate) {
    return this.httpService.callService(
      HttpMethodType.PUT,
      HttpServiceMethods.NotificationTemplate,
      parameterType
    );
  }

  public delete(id: number) {
    return this.httpService.callService(
      HttpMethodType.DELETE,
      HttpServiceMethods.NotificationTemplate + `/${id}`
    );
  }
}
